import { render } from "./CouponUsage.vue?vue&type=template&id=03a6a068&scoped=true"
import script from "./CouponUsage.vue?vue&type=script&lang=js"
export * from "./CouponUsage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-03a6a068"

export default script